import { RunLogEntry } from '../types';

const isFiniteNumber = (n: unknown): n is number => typeof n === 'number' && Number.isFinite(n);

export function isRunLogEntry(x: unknown): x is RunLogEntry {
  if (!x || typeof x !== 'object') return false;
  const e = x as Record<string, unknown>;
  return (
    typeof e.id === 'string' &&
    typeof e.date === 'string' &&
    !Number.isNaN(Date.parse(e.date)) &&
    isFiniteNumber(e.distanceKm) && e.distanceKm > 0 &&
    isFiniteNumber(e.totalSeconds) && e.totalSeconds > 0 &&
    isFiniteNumber(e.paceSecondsPerKm) && e.paceSecondsPerKm > 0 &&
    (e.title === undefined || typeof e.title === 'string')
  );
}

/** Houdt alleen geldige runs over; een kapotte opslag levert dus een lege lijst, geen crash. */
export function parseRunLogs(raw: unknown): RunLogEntry[] | undefined {
  if (!Array.isArray(raw)) return undefined;
  return raw.filter(isRunLogEntry).map((e) => ({
    ...e,
    title: e.title ?? '',
    speedKmh: isFiniteNumber(e.speedKmh) ? e.speedKmh : (e.distanceKm / e.totalSeconds) * 3600,
    feeling: ([1, 2, 3, 4, 5] as const).includes(e.feeling) ? e.feeling : 3,
  }));
}
